/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import {
	Box,
	Flex,
	Icon,
	Grid,
	GridItem,
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Text,
	Skeleton,
	Image,
	chakra,
	InputGroup,
	InputRightElement,
	HStack,
} from '@chakra-ui/react'
import { useLoadStatusAndActivityType } from '../../../hooks/activity.hooks'
import { useAuthContext } from '../../../context/auth.context'
import { useLanguageContext } from '../../../context/locale.context'
import { groupBy } from 'lodash'
import { ACTION_PANEL_VIEW } from '../action-panel'
import { AiOutlineClose } from 'react-icons/ai'
import { MdSearch } from 'react-icons/md'
import { sectionDetailedTrack } from '../../repository/repo.utils'
import { GA_CATEGORY_FILES } from './../../repository/repo.utils'
import InputText from '../../../components/globalComponents/inputText'
import SVGIcon from '../../../assets/svgIcons'

const StatusActivityTypeView = ({
	setpanelView,
	selectedQueue,
	selectedFilter,
	selectedStatus,
	setSelectedStatus,
	statusIndex,
	setStatusIndex,
	queue,
}) => {
	const radioButtons = {
		All: true,
		Lead: false,
		Owner: false,
		Participant: false,
	}
	const flagAssetFilter = {
		All: 0,
		Lead: 1,
		Owner: 2,
		Participant: 3,
	}
	const activeRadioRef = useRef('All')

	const { mutate, isLoading, isError } = useLoadStatusAndActivityType()

	const [data, setdata] = useState(null)
	const [searchString, setSearchString] = useState('')
	const [isRadioChecked, setIsRadioChecked] = useState(radioButtons)
	const [activeRadio, setActiveRadio] = useState('All')
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const { organization_flag_enable_tag } = authData

	useEffect(() => {
		mutate(
			{
				flag: selectedQueue.filterFlag || 0,
				flag_asset_filter: flagAssetFilter[activeRadio],
			},
			{
				onSuccess: async data => {
					let groupedData
					if (organization_flag_enable_tag === 1) {
						groupedData = groupBy(data, 'tag_type_id')
					} else {
						groupedData = groupBy(data, 'activity_type_category_id')
					}
					setdata(groupedData)
				},
			}
		)
	}, [activeRadio])

	let filteredData = {}

	;(function () {
		if (searchString === '') filteredData = data

		const regex = new RegExp(searchString, 'i')

		!!data &&
			Object.keys(data).forEach((item, i) => {
				const second = data[item].filter((item2, j) => {
					if (
						regex.test(item2.activity_type_name) ||
						regex.test(item2.activity_status_name) ||
						regex.test(item2.tag_type_name)
					)
						return true
					return false
				})
				if (second.length > 0) filteredData[item] = second
			})
	})()

	//organization_flag_enable_tag
	return (
		<Grid
			h='calc(100% - 100px)'
			bg='white'
			w='100%'
			gridTemplateRows='1fr 15fr'
		>
			<GridItem>
				<Flex w='100%' flexBasis='2%'>
					<Box pb='1.25rem' pl='1.25rem' pt='1.25rem'>
						{/* <Image
							src={greneIcon}
							maxW='2.25rem'
							ml={8}
							display='inline-block'
							mb={0}
							mr={1}
						/> */}
						<Box mr={1} ml={8} display='inline-block'>
							<SVGIcon
								iconName='GreenLogoLineSvg'
								svgProps={{
									width: '36',
									height: '10',
									viewBox: '0 0 36 10',
								}}
								// pathProps={{ fill: '#009B76' }}
							/>
						</Box>

						<chakra.span color='#000000' fontSize='16px' fontWeight={500}>
							&nbsp; {locale['Filter Requests']}
						</chakra.span>
					</Box>
					<Icon
						className={`status-activity-view-back-icon`}
						as={AiOutlineClose}
						cursor='pointer'
						color='red.600'
						w={5}
						h={5}
						ml='auto'
						mr='1.7rem'
						mt='1rem'
						onClick={() => {
							sectionDetailedTrack({
								category: GA_CATEGORY_FILES,
								action: 'Activity Status View',
								label: 'Go Back',
							})
							setStatusIndex({ cat: 0, sub_cat: null })
							setpanelView(ACTION_PANEL_VIEW.LIST_VIEW)
						}}
					/>
				</Flex>
				<Flex
					flexDir={'column'}
					justifyContent='space-around'
					px='10px'
					mb='20px'
				>
					<Box p='10px'>
						<Text color='#141313' fontWeight={'400'} fontSize='14px'>
							{locale['Participation type']}
						</Text>
					</Box>
					<HStack px='10px' justifyContent='space-between'>
						<Box
							display='flex'
							justifyContent={'space-between'}
							alignItems='center'
							gap='4px'
						>
							<Box
								display='flex'
								alignItems='center'
								justifyContent='center'
								w='15px'
								h='15px'
								borderRadius='50%'
								border='1.5px solid'
								borderColor={isRadioChecked['All'] ? '#666' : '#009B76'}
								onClick={() => {
									activeRadioRef.current === 'All'
										? setIsRadioChecked({
												...isRadioChecked,
												['All']: true,
										  })
										: setIsRadioChecked({
												...isRadioChecked,
												[activeRadioRef.current]: false,
												['All']: true,
										  })
									activeRadioRef.current = 'All'
									setActiveRadio('All')
								}}
							>
								<Box
									display={isRadioChecked['All'] ? 'block' : 'none'}
									w='9px'
									h='9px'
									bg='#666'
									borderRadius='50%'
								></Box>
							</Box>
							<Box>
								<Text color='#009B76'>{locale['All']}</Text>
							</Box>
						</Box>
						<Box
							display='flex'
							justifyContent={'space-between'}
							alignItems='center'
							gap='4px'
						>
							<Box
								display='flex'
								alignItems='center'
								justifyContent='center'
								w='15px'
								h='15px'
								borderRadius='50%'
								border='1.5px solid'
								borderColor={isRadioChecked['Lead'] ? '#666' : '#009B76'}
								onClick={() => {
									activeRadioRef.current === 'Lead'
										? setIsRadioChecked({
												...isRadioChecked,
												['Lead']: true,
										  })
										: setIsRadioChecked({
												...isRadioChecked,
												[activeRadioRef.current]: false,
												['Lead']: true,
										  })
									activeRadioRef.current = 'Lead'
									setActiveRadio('Lead')
								}}
							>
								<Box
									display={isRadioChecked['Lead'] ? 'block' : 'none'}
									w='9px'
									h='9px'
									bg='#666'
									borderRadius='50%'
								></Box>
							</Box>
							<Box>
								<Text color='#009B76'>{locale['Lead']}</Text>
							</Box>
						</Box>
						<Box
							display='flex'
							justifyContent={'space-between'}
							alignItems='center'
							gap='4px'
						>
							<Box
								display='flex'
								alignItems='center'
								justifyContent='center'
								w='15px'
								h='15px'
								borderRadius='50%'
								border='1.5px solid'
								borderColor={isRadioChecked['Owner'] ? '#666' : '#009B76'}
								onClick={() => {
									activeRadioRef.current === 'Owner'
										? setIsRadioChecked({
												...isRadioChecked,
												['Owner']: true,
										  })
										: setIsRadioChecked({
												...isRadioChecked,
												[activeRadioRef.current]: false,
												['Owner']: true,
										  })
									activeRadioRef.current = 'Owner'
									setActiveRadio('Owner')
								}}
							>
								<Box
									display={isRadioChecked['Owner'] ? 'block' : 'none'}
									w='9px'
									h='9px'
									bg='#666'
									borderRadius='50%'
								></Box>
							</Box>
							<Box>
								<Text color='#009B76'>{locale['Owner']}</Text>
							</Box>
						</Box>
						<Box
							display='flex'
							justifyContent={'space-between'}
							alignItems='center'
							gap='4px'
						>
							<Box
								display='flex'
								alignItems='center'
								justifyContent='center'
								w='15px'
								h='15px'
								borderRadius='50%'
								border='1.5px solid'
								borderColor={isRadioChecked['Participant'] ? '#666' : '#009B76'}
								onClick={() => {
									activeRadioRef.current === 'Participant'
										? setIsRadioChecked({
												...isRadioChecked,
												['Participant']: true,
										  })
										: setIsRadioChecked({
												...isRadioChecked,
												[activeRadioRef.current]: false,
												['Participant']: true,
										  })
									activeRadioRef.current = 'Participant'
									setActiveRadio('Participant')
								}}
							>
								<Box
									display={isRadioChecked['Participant'] ? 'block' : 'none'}
									w='9px'
									h='9px'
									bg='#666'
									borderRadius='50%'
								></Box>
							</Box>
							<Box>
								<Text color='#009B76'>{locale['Participant']}</Text>
							</Box>
						</Box>
					</HStack>
				</Flex>
				<InputGroup w='100%' mb={2} px={4}>
					<InputText
						border='1px solid #D9D9D9'
						type='text'
						height='36px'
						fontStyle='normal'
						color='#131D0B'
						fontWeight='400'
						fontSize='0.875rem'
						placeholder={`${locale['Search']} ${locale['Filter']}`}
						_placeholder={{ color: '#5A5A5A' }}
						value={searchString}
						onChange={e => {
							setSearchString(e.target.value)
						}}
						borderRadius='18px'
					/>
					<InputRightElement
						pointerEvents='none'
						color='green.500'
						right={4}
						children={<MdSearch fontSize='25' />}
					/>
				</InputGroup>
			</GridItem>
			{/* <Text>
          <Text as="span" fontWeight="900">
            {selectedQueue.queue_name || selectedFilter.activity_type_name}
          </Text>
        </Text> */}
			<GridItem overflowY='scroll'>
				<Accordion
					flexGrow='1'
					flexBasis='98%'
					allowToggle={true}
					_before={{
						border: 'none',
					}}
					w='full'
					bg='white'
					px={1}
					onChange={e => {
						setStatusIndex({ cat: e, sub_cat: 0 })
					}}
				>
					{!isLoading && !!filteredData && !Object.keys(filteredData).length ? (
						<Flex alignItems='center' justifyContent='center'>
							<Text>{locale['No content found!']}</Text>
						</Flex>
					) : isLoading ? (
						[1, 2, 3, 4, 5].map(i => {
							return (
								<Skeleton
									boxShadow='md'
									borderRadius='md'
									key={i}
									mb={2}
									w='full'
									h='50px'
								/>
							)
						})
					) : (
						!!filteredData &&
						Object.keys(filteredData).map((activity_type_category_id, i) => {
							return (
								<AccordionItem
									borderTopWidth='0'
									key={i}
									index={i + 1}
									_last={{
										borderBottomWidth: '0',
									}}
								>
									<AccordionButton
										pb='0.75rem'
										pt='0.75rem'
										borderBottom='1px solid #F1F3F9'
										_hover={{
											background: 'transparent',
										}}
									>
										<Box
											flex='1'
											textAlign='left'
											cursor='pointer'
											onClick={e => {
												sectionDetailedTrack({
													category: GA_CATEGORY_FILES,
													action: 'Activity Status View',
													label: 'Switch To List View',
												})
												setSelectedStatus({
													...filteredData[activity_type_category_id][0],
													activity_status_id: 0,
													activity_type_id: 0,
													activity_status_type_id: 0,
													hideStatus: true,
													hideCategory: true,
													cat_index: i + 1,
													sub_cat_index: null,
													tag_id: 0,
													radio_button_id: flagAssetFilter[activeRadio],
												})
												setpanelView(ACTION_PANEL_VIEW.LIST_VIEW)
												e.stopPropagation()
											}}
										>
											<Text fontWeight='500' fontSize='0.875rem'>
												{organization_flag_enable_tag === 1
													? filteredData[activity_type_category_id][0]
															.tag_type_name
														? filteredData[
																activity_type_category_id
														  ][0].tag_type_name.endsWith('y')
															? `My ` +
															  filteredData[
																	activity_type_category_id
															  ][0].tag_type_name.slice(0, -1) +
															  'ies'
															: `My ` +
															  filteredData[activity_type_category_id][0]
																	.tag_type_name +
															  's'
														: locale['Others']
													: `My ` +
													  filteredData[activity_type_category_id][0]
															.activity_type_category_name +
													  `s`}
											</Text>
										</Box>
										<AccordionIcon />
									</AccordionButton>
									<AccordionPanel overflowY='auto' p={0} pl='1.25rem'>
										<Accordion
											_before={{
												border: 'none',
											}}
											allowToggle={true}
										>
											{Object.keys(
												groupBy(
													filteredData[activity_type_category_id],
													'activity_type_name'
												) || []
											).map((activity_type_name, j) => {
												return (
													<AccordionItem
														borderTopWidth='0'
														key={Math.random().toString()}
														index={j}
														_last={{
															borderBottomWidth: '0',
														}}
													>
														<AccordionButton
															color='green.700'
															pb='0.75rem'
															pt='0.75rem'
															borderBottom='1px solid #F1F3F9'
															_hover={{
																background: 'transparent',
															}}
														>
															<Box
																flex='1'
																textAlign='left'
																cursor='pointer'
																className='ccd'
																onClick={e => {
																	sectionDetailedTrack({
																		category: GA_CATEGORY_FILES,
																		action: 'Activity Status View',
																		label: 'Switch To List View',
																	})
																	setSelectedStatus({
																		...groupBy(
																			filteredData[activity_type_category_id],
																			'activity_type_name'
																		)[activity_type_name][0],
																		activity_status_id: 0,
																		activity_status_type_id: 0,
																		hideStatus: true,
																		cat_index: i + 1,
																		sub_cat_index: j,
																		radio_button_id:
																			flagAssetFilter[activeRadio],
																	})
																	setpanelView(ACTION_PANEL_VIEW.LIST_VIEW)
																	e.stopPropagation()
																}}
															>
																<Text fontWeight='500' fontSize='0.875rem'>
																	{activity_type_name}
																</Text>
															</Box>
															<AccordionIcon />
														</AccordionButton>
														<AccordionPanel overflowY='auto' p={0} pl='2.5rem'>
															{groupBy(
																filteredData[activity_type_category_id],
																'activity_type_name'
															)[activity_type_name].map(
																(activity_status_name, k) => {
																	return (
																		<div key={`${activity_status_name}-${k}`}>
																			{activity_status_name?.activity_status_name && (
																				<Box
																					cursor='pointer'
																					pb='0.75rem'
																					pt='0.75rem'
																					borderBottom='1px solid #F1F3F9'
																					onClick={e => {
																						sectionDetailedTrack({
																							category: GA_CATEGORY_FILES,
																							action: 'Activity Status View',
																							label: 'Activity List View',
																						})
																						setSelectedStatus({
																							...activity_status_name,
																							cat_index: i + 1,
																							sub_cat_index: j,
																							radio_button_id:
																								flagAssetFilter[activeRadio],
																						})
																						setpanelView(
																							ACTION_PANEL_VIEW.LIST_VIEW
																						)
																						e.stopPropagation()
																					}}
																				>
																					<Text
																						fontSize='0.875rem'
																						fontWeight='500'
																					>
																						{
																							activity_status_name?.activity_status_name
																						}
																					</Text>
																				</Box>
																			)}
																		</div>
																	)
																}
															)}
														</AccordionPanel>
													</AccordionItem>
												)
											})}
										</Accordion>
									</AccordionPanel>
								</AccordionItem>
							)
						})
					)}
				</Accordion>
			</GridItem>
		</Grid>
	)
}

export default StatusActivityTypeView
